// extracted by mini-css-extract-plugin
export default {"label":"FeatureItem_label__z1Oou"};